import { render, staticRenderFns } from "./ContactsPanel.vue?vue&type=template&id=fc2fa2ec&scoped=true"
import script from "./ContactsPanel.vue?vue&type=script&lang=js"
export * from "./ContactsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2fa2ec",
  null
  
)

export default component.exports